import { render, staticRenderFns } from "./tasks-create-form.vue?vue&type=template&id=480f9135&"
import script from "./tasks-create-form.vue?vue&type=script&lang=js&"
export * from "./tasks-create-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports